export const EMAIL_VALIDATOR = "^[\\w\\d\\._%+\\-]+@[\\w\\d\\.\\-]+\\.[\\w]+$";
export const PASSWORD_VALIDATOR = "^(?=.*[A-Z])(?=.*[a-z])(?=.*\\d).{6,}$";
export const OFFER_INFO_VALIDATOR = "^[^а-яА-ЯёЁ]+$";
export const DOMAIN_NAME_VALIDATOR = "^((?!-)[a-z0-9\\-]{1,67}(?<!-)\\.)+[a-z]{2,6}$";
export const U_ID_VALIDATOR = "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$";
export const FULL_NAME_VALIDATOR = "^[A-zА-яё\\s]+$";